/**
 * @class LicenseMachineInformation
 */
export default class LicenseMachineInformation {
    /**
     * @param   {String}    serialNumber
     * @param   {String}    producer
     * @param   {String}    type
     * @param   {String}    numberOfCanisters
     */
    constructor(serialNumber = "", producer = "", type = "", numberOfCanisters = "") {
        this._serialNumber = serialNumber;
        this._producer = producer;
        this._type = type;
        this._numberOfCanisters = numberOfCanisters;
    }

    /**
     * @return {String}
     */
    get serialNumber() {
        return this._serialNumber;
    }

    /**
     * @param {String} serialNumber
     */
    set serialNumber(serialNumber) {
        this._serialNumber = serialNumber;
    }

    /**
     * @return {String}
     */
    get producer() {
        return this._producer;
    }

    /**
     * @param {String} producer
     */
    set producer(producer) {
        this._producer = producer;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {String}
     */
    get numberOfCanisters() {
        return this._numberOfCanisters;
    }

    /**
     * @param {String} numberOfCanisters
     */
    set numberOfCanisters(numberOfCanisters) {
        this._numberOfCanisters = numberOfCanisters;
    }
}
